import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { usePurchasedGoodsInsightsRetrieve } from '@shared/api/lib/purchased-goods/purchased-goods';
import {
  PurchasedGoodsInsights,
  PurchasedGoodsInsightsRetrieveParams,
} from '@shared/api/types';

/**
 * Aggregated purchased goods insights (totals, emissions-over-time, the
 * groupBy breakdown page, and available filter options) for the requesting
 * organisation.
 */
export const useGetPurchasedGoodsInsights = (
  params?: PurchasedGoodsInsightsRetrieveParams,
  options?: { enabled?: boolean }
) =>
  usePurchasedGoodsInsightsRetrieve<PurchasedGoodsInsights>(params, {
    // The aggregation can be slow; bound it so a hung request surfaces as an
    // error instead of waiting forever.
    request: { ...useAxiosConfig(), timeout: 30_000 },
    query: {
      keepPreviousData: true,
      enabled: options?.enabled,
      // Every fetch is tracked as a Queried PG Insights analytics event, so
      // don't refire on tab focus — it's a heavy aggregation anyway.
      refetchOnWindowFocus: false,
    },
  });
